import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import CheckoutSummary from "../../components/Order/CheckoutSummary/CheckoutSummary";

import ContactData from "./ContactData/ContactData";

class Checkout extends Component {
  // constructor(props) {
  //   super(props);
  //   const query = new URLSearchParams(this.props.location.search);

  //   const ingredients = {};
  //   let price = 0;
  //   for (let param of query.entries()) {
  //     if (param[0] === "price") {
  //       price = +param[1];
  //     } else {
  //       ingredients[param[0]] = +param[1];
  //     }
  //   }
  //   this.state = { ingredients: ingredients, totalPrice: price };
  // }

  state = {
    // ingredients: false,
    checkoutClicked: false,
    // totalPrice: 0,
  };

  checkoutCancelledHandler = () => {
    this.props.history.goBack();
  };
  checkoutContinuedHandler = () => {
    this.setState({ checkoutClicked: true });
    this.props.history.replace("/checkout/contact-data");
  };
  render() {
    let summary = <Redirect to="/" />;
    const purchasedRedirect = this.props.purchased ? <Redirect to="/" /> : null;
    if (this.props.ings) {
      summary = (
        <div>
          {purchasedRedirect}
          <CheckoutSummary
            hasIngredient={this.props.ings}
            ingredients={this.props.ings}
            // hasIngredient={this.state.ingredients}
            // ingredients={this.state.ingredients}
            checkoutCancelled={this.checkoutCancelledHandler}
            checkoutContinued={this.checkoutContinuedHandler}
            checked={this.state.checkoutClicked}
          />
          <Route
            path={this.props.match.path + "/contact-data"}
            component={ContactData}
          />
        </div>
      );
    }

    return summary;
  }
}

const mapStateToProps = (state) => {
  return {
    ings: state.brg.ingredients,
    purchased: state.ord.purchased,
    // price: state.totalPrice,
  };
};

export default connect(mapStateToProps)(Checkout);
